import { SelfBillKind } from 'src/types/enums';
import { SELF_BILL_LIST_PATHS } from '../paths';

export interface ISelfBillKindConfig {
  /** Page title and breadcrumb. */
  title: string;
  /** One document, at the start of a sentence: "Ritoverzicht goedgekeurd". */
  documentName: string;
  /** Several documents, lowercase: "3 ritoverzichten". */
  pluralName: string;
  /** One document with its article, lowercase: "dit ritoverzicht", "deze self billing". */
  documentWithArticle: string;
  /** Label of the number a document gets at approval. */
  numberLabel: string;
  listPath: string;
  /** Self-billing invoices go out over Peppol; a ride overview never does. */
  hasPeppol: boolean;
  /** Only self-billing invoices are booked in Exact. */
  canExportToExact: boolean;
  /** A self-billing invoice gets its AKF on approval; a ride overview is converted by hand. */
  createsPurchaseOnApproval: boolean;
  /** Self-billing pays into the carrier's account; for a ride overview the carrier invoices us. */
  requiresIban: boolean;
}

export const SELF_BILL_KIND_CONFIG: Record<SelfBillKind, ISelfBillKindConfig> = {
  [SelfBillKind.RideOverview]: {
    title: 'Ritoverzichten',
    documentName: 'Ritoverzicht',
    pluralName: 'ritoverzichten',
    documentWithArticle: 'dit ritoverzicht',
    numberLabel: 'Nummer',
    listPath: SELF_BILL_LIST_PATHS[SelfBillKind.RideOverview],
    hasPeppol: false,
    canExportToExact: false,
    createsPurchaseOnApproval: false,
    requiresIban: false,
  },
  [SelfBillKind.SelfBilling]: {
    title: 'Self billing',
    documentName: 'Self billing',
    pluralName: 'self billings',
    documentWithArticle: 'deze self billing',
    numberLabel: 'Factuurnummer',
    listPath: SELF_BILL_LIST_PATHS[SelfBillKind.SelfBilling],
    hasPeppol: true,
    canExportToExact: true,
    createsPurchaseOnApproval: true,
    requiresIban: true,
  },
};

/** "1 ritoverzicht", "3 ritoverzichten". */
export function countSelfBills(config: ISelfBillKindConfig, count: number): string {
  return `${count} ${count === 1 ? config.documentName.toLowerCase() : config.pluralName}`;
}
